import React from 'react';
import Typography from 'Components/UI/Typography';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Divider from 'Components/UI/Divider';
import {
  BENCHMARK_CHART_COLOR,
  BENCHMARK_CHART_NAME,
  PERFORMANCE_CHART_COLOR,
  PERFORMANCE_CHART_NAME,
} from './accountPerformance.consts';

const tooltipStyles = buildUseStyles('AccountPerformanceChartTooltip', (theme) => ({
  tooltip: {
    backgroundColor: theme.palette.facet.lightGray,
    padding: theme.spacing(2),
    borderRadius: theme.radius.md,
    outlineWidth: 0,

  },
  chartValues: {
    display: 'flex',
    gap: theme.spacing(2),
  },
  tooltipPerformance: {
    color: PERFORMANCE_CHART_COLOR,
  },
  tooltipBenchmark: {
    color: BENCHMARK_CHART_COLOR,
  },
  showAllButton: {
    pointerEvents: 'auto',
  },
}));

export default function AccountPerformanceChartTooltip({ payload, label, showBenchmark }) {
  const classes = tooltipStyles();

  if (!payload?.length) return null;

  const date = new Date(label);
  let performance = '0';
  let benchmark = '0';
  let modelChangeAllocationType = null;
  let equityBenchmark = '';
  let fixedIncomeBenchmark = '';
  let cashBenchmark = '';
  let altsBenchmark = '';
  let altsSubLabel1 = '';
  let altsSubLabel2 = '';
  if (payload) {
    for (const data of payload) {
      if (data.name === PERFORMANCE_CHART_NAME) {
        performance = `${data.value}%`;

        const modelChangeEvent = data.payload.modelChangeEvents?.resources().last();
        if (modelChangeEvent) {
          modelChangeAllocationType = modelChangeEvent.attr('toModel');
          equityBenchmark = modelChangeEvent.attr('benchmarkEquities');
          fixedIncomeBenchmark = modelChangeEvent.attr('benchmarkBond');
          cashBenchmark = modelChangeEvent.attr('benchmarkCash');
          altsBenchmark = modelChangeEvent.attr('benchmarkAlts');
          altsSubLabel1 = modelChangeEvent.attr('benchmarkAltsSubLabel1');
          altsSubLabel2 = modelChangeEvent.attr('benchmarkAltsSubLabel2');
        }
      } else if (data.name === BENCHMARK_CHART_NAME) {
        benchmark = `${data.value}%`;
      }
    }
  }

  return (<>
    <Box className={classes.tooltip}>
      <Typography variant="h6">{date.toLocaleDateString(undefined, {
        day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC',
      })}
      </Typography>
      <Divider />
      <Box className={classes.chartValues}>
        <Box>
          <Typography variant="h6" color="primaryGray2">{PERFORMANCE_CHART_NAME}</Typography>
          <Typography variant="h6" weight="bold" className={classes.tooltipPerformance}>{performance}</Typography>
        </Box>

        {showBenchmark && (
          <Box>
            <Typography variant="h6" color="primaryGray2">{BENCHMARK_CHART_NAME}</Typography>
            <Typography variant="h6" weight="bold" className={classes.tooltipBenchmark}>{benchmark}</Typography>
          </Box>
        )}
      </Box>

      {modelChangeAllocationType ? <>
        <Box marginTop={1} display="flex" flexDirection="column">
          <Typography variant="h6" color="primaryGray2">Allocation Update</Typography>
          <Typography variant="h6" weight="bold">{modelChangeAllocationType}</Typography>
        </Box>
        {showBenchmark && (
        <Box>
          <Typography variant="h6" color="primaryGray2">Benchmark Update:</Typography>
          <Typography variant="h6" weight="bold">{equityBenchmark}</Typography>
          <Typography variant="h6" weight="bold">{fixedIncomeBenchmark}</Typography>
          <Typography variant="h6" weight="bold">{cashBenchmark}</Typography>
          <Typography variant="h6" weight="bold">{altsBenchmark}</Typography>
          {
            altsSubLabel1 && altsSubLabel2 && (
            <ul style={{ paddingTop: 0, marginTop: 0 }}>
              <li>
                <Typography variant="h6" weight="bold">{altsSubLabel1}</Typography>
              </li>
              <li>
                <Typography variant="h6" weight="bold">{altsSubLabel2}</Typography>
              </li>
            </ul>
            )
          }
        </Box>
        )}
      </> : null}
    </Box>
  </>);
}
